/** Figma pony/operated-by: "Service opéré par" caption + the pony logotype, centred. */
export function OperatedBy(props: { class?: string }) {
  return (
    <p
      class={`flex items-center justify-center gap-[5px] text-[12px] leading-[1.25] tracking-[0.12px] text-text ${props.class ?? ""}`}
    >
      Service opéré par
      <img src="/icons/pony-logotype-indigo.svg" width="31" height="15" alt="Pony" />
    </p>
  );
}
